"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageableConverter = void 0;
const LinkEntity_1 = require("./LinkEntity");
class PageableConverter {
    static convert(pageableEntity, key, embeddedConverter) {
        let pageSpec;
        if (pageableEntity.page) {
            pageSpec = {
                pageSpec: {
                    number: pageableEntity.page.number,
                    size: pageableEntity.page.size,
                    totalElements: pageableEntity.page.totalElements,
                    totalPages: pageableEntity.page.totalPages,
                    nextPage: pageableEntity._links &&
                        pageableEntity._links.next &&
                        new LinkEntity_1.Link(pageableEntity._links.next),
                    previousPage: pageableEntity._links &&
                        pageableEntity._links.prev &&
                        new LinkEntity_1.Link(pageableEntity._links.prev),
                },
            };
        }
        return {
            ...pageSpec,
            page: pageableEntity._embedded[key].map(embeddedConverter),
        };
    }
}
exports.PageableConverter = PageableConverter;
//# sourceMappingURL=PageableConverter.js.map